module.exports = __webpack_public_path__ + "static/powerbi-odata-url-single-481b36c4e6837c61bd0920cbd84dbc26.png";